var global = require('../internals/global');

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/define-global-property.js
// module id = 246
// module chunks = 0